import { useState } from 'react';
import { useZebraPrinter } from './useZebraPrinter';


export const PrintZPL = () => {

    // para utilizar este componente debe seguir los siguientes pasos:
    // 1 el programa debe estar corriendo en localhost o en https
    // 2 se debe instalae el programa zadig
    // 3. al executar el programa en como administrador se debe seleccionar las opciones listar todos los dispositivos
    // 4. buscar el dispositivo de la impresora (conectada por usb o red)
    // 5. remplazar el driver y listo

    const [zplCommand, setZplCommand ] = useState<string>('');
    const PrinterComponent =() => {
        const { print, isPrinting, error } = useZebraPrinter();

        const handlePrint = async () => {
            // const zpl = `^XA\n^MNY,0\n^JS10\n^FO0,0\n^CF0,15\n^FO180,42^FD830141901-  ADVANTAGE MIC^FS\n^FO180,64^FDnull-null^FS\n^FO180,86^FD1071^FS\n^FO180,108^FDSN: NA^FS\n^FO180,130^FDMarca: NA^FS\n^FX Third section with barcode\n^FO0,0\n^CF0,15\n^BY2,2,20\n^FO10,0\n^BQN,4,5^FD  1071^FS\n^FO0,0\n^XZ`;
            
            try {
                await print(zplCommand);
                alert('Impresión exitosa!');
            } catch {
                // Error ya está manejado en el hook
            }
        };

        return (
            <div>
                <button onClick={handlePrint} disabled={isPrinting}>
                    {isPrinting ? 'Imprimiendo...' : 'Imprimir'}
                </button>
                {error && <div className="error">{error}</div>}
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col">
                <textarea className='form-control' value={zplCommand} onChange={(e)=>{setZplCommand(e.target.value)}}></textarea>
                {PrinterComponent()}
            </div>
        </div>
    )
}